
import React from "react"
import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { Col, Row } from "reactstrap"




import { TextFieldHookForm, SearchableSelectHookForm } from "./layout/HookFormInputs"
import { decimalLengthsix, maxLength15, number, positiveAndDecimalNumber } from "../helper"
import { setSAPData } from "./costing/actions/Approval"



function SAPApproval(props) {

    const { Controller, control, errors, register } = props



    const dispatch = useDispatch()
    const SAPData = useSelector(state => state.approval.SAPObj)


    const dropDown = [
        {
            label: 'Standard',
            value: 0
        },
        {
            label: 'Sub-Contracting',
            value: 1,
        },

    ]



    /**
    * @Method renderListing
    * @description Dropdown data list
    */
    const renderListing = (label) => {

        if (label === 'infoCategeory') {
            return dropDown
        }
    }


    const handleinfoCategory = (value) => {

        dispatch(setSAPData({ ...SAPData, infoCategory: value?.value }))
    }
    const handleLeadTime = (e) => {

        dispatch(setSAPData({ ...SAPData, leadTime: e.target.value }))
    }



    return (
        <>
            <div >

                {<Row>

                    {/* <Col md=
                        {props?.isSimulation ? "12" : "3"}>
                        <SearchableSelectHookForm
                            label={"Info Categeory"}
                            name={"infoCategeory"}
                            placeholder={"Select"}
                            Controller={Controller}
                            control={control}
                            rules={{ required: true }}
                            register={register}
                            defaultValue={""}
                            options={renderListing("infoCategeory")}
                            mandatory={true}
                            handleChange={handleinfoCategory}
                            errors={errors.infoCategeory}
                            disabled={false}
                        />
                    </Col> */}
                    <Col md=
                        {props?.isSimulation ? "12" : "3"}>
                        <TextFieldHookForm
                            label={`Lead Time (Days)`}
                            name={"leadTime"}
                            placeholder={"-"}
                            Controller={Controller}
                            control={control}
                            register={register}
                            rules={{
                                required: true,
                                validate: { positiveAndDecimalNumber, maxLength15, decimalLengthsix, number },
                            }}
                            disabled={false}
                            className=" "
                            handleChange={handleLeadTime}
                            customClassName=" withBorder"
                            mandatory={true}
                            errors={errors.leadTime}
                        />
                    </Col>
                </Row>}


            </div>
        </>
    )
}
export default SAPApproval